import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ToastMessage {
  kind: 'info' | 'success' | 'error';
  text: string;
}

/**
 * Minimal toast bus. WS-4 will replace this with a richer LSLTool-style
 * notification component; for the shell we just emit messages on a Subject
 * that a future toast container component subscribes to.
 */
@Injectable({ providedIn: 'root' })
export class NotificationService {
  private readonly bus$ = new Subject<ToastMessage>();
  readonly toasts$ = this.bus$.asObservable();

  info(text: string): void {
    this.bus$.next({ kind: 'info', text });
  }
  success(text: string): void {
    this.bus$.next({ kind: 'success', text });
  }
  error(text: string): void {
    this.bus$.next({ kind: 'error', text });
  }
}
